import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { ProjectOverviewComponent } from './project-overview/project-overview.component';
import { AssignmentOverviewComponent } from './assignments/assignment-overview/assignment-overview.component';
import { NotFoundComponent } from '../../not-found/not-found.component';
import { ProjectsComponent } from './projects.component';
import { leavePageGuard } from 'src/app/core/guards/leave-page.guard';
import { ProjectFilesComponent } from './project-files/project-files.component';

const routes: Routes = [
  {
    path: ':projectId/assignments/create',
    redirectTo: ':projectId',
    pathMatch: 'full',
  },
  {
    path: ':projectId/assignments/:id',
    component: AssignmentOverviewComponent,
    canDeactivate: [leavePageGuard],
  },
  { path: ':projectId/files', component: ProjectFilesComponent },
  { path: 'create', redirectTo: '', pathMatch: 'full' },
  { path: ':id', component: ProjectOverviewComponent },
  { path: '', component: ProjectsComponent },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProjectsRoutingModule {}
